import { createSlice } from "@reduxjs/toolkit";


interface AuthUser {
    id: string;
    name: string;
    email: string;
    photo_url: string | undefined;
    role:"Admin"| "Doctor"| "Nurse"| "Staff"| "Technician"| "clinical_staff"| "Clinical_reviewer"| "Patient"| "email_Manager"| "SMS_Manager"| "Nutritionist"| "CareCoordinator" |null;
    isClinical: boolean;
    username?: string;
    associated_branch?: string;
    associated_branch_name?: string;
    associated_state_name?: string;
    hospital_name?: string;
}




const user: AuthUser = {
    id: "",
    name: "",
    photo_url: "",
    email: "",
    role: null,
    isClinical: false,
    username: ""
};

const initialState = {
  token: "",
  user: user,
  expiresIn: "",
};
const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuth: (state, action) => {
      Object.assign(state, action.payload);
    },
    logOut: (state) => {
      state.token = initialState.token
      state.user = initialState.user
      state.expiresIn = initialState.expiresIn
    },
  },
});

export const { setAuth, logOut } = authSlice.actions;

export default authSlice.reducer;
